import { Box } from "@mui/material";

const UserImage = ({ image, size = "60px" }) => {
  const serverIp = process.env.REACT_APP_SERVER_IP || 'http://localhost:3001';

  return (

    <Box width={size} height={size}>
      <img
        style={{ objectFit: "cover", borderRadius: "50%" }}
        width={size}
        height={size}
        alt="user"
        src={`${serverIp}/assets/${image}`}
      />
    </Box>
  );
};

export default UserImage;
